import { FinancialDataRow } from '@policyvision/contracts';

import { TableCell, TableRow } from '@/common/components/ui/table';

interface FinancialDataTableRowsProps {
  rows: FinancialDataRow[];
}

export const FinancialDataTableRows = ({
  rows,
}: FinancialDataTableRowsProps) => {
  return rows.map((row) => (
    <TableRow key={row.key} className="bg-white even:bg-white">
      <TableCell className="border-r border-warm-gray-200 whitespace-normal">
        {row.key}
      </TableCell>

      <TableCell className="border-r border-warm-gray-200 whitespace-normal text-right">
        {row.value}
      </TableCell>
    </TableRow>
  ));
};
